import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import kanbanService from '../../service/kanban.service';
import { useLoader } from '../../provider/LoaderProvider';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';

import useParam from '../../context/ParamContext';
import useUsers from '../../context/UsersContext';
import {
  ViewType,
  KanbanType,
  conditions,
  KanbanFilterFormState,
  NavigateUrlToKanbanType,
  KanbanDialog,
  KanbanTypeToSubMenuUrl,
  AddIconVisibleForTypes,
  filterFieldConfig,
  KanbanTypeToPermissionSubMenuUrl,
  PriorityVisibleForTypes,
  orderColumnsByType,
  TagEnabledForTypes,
  OptionalKanbanTypes,
} from '../../config/kanban';
import { generateAutocompleteItems, generateFilter } from '../../utils/helper';
import useSaveView from '../../hooks/useSaveView';
import useView from '../../hooks/useView';
import Card from './Card';
import { ColorDialogUI, TooltipUI } from '../Interface';
import Dialog from './Dialog';
import MessageDialog from './MessageDialog';
import masterDataService from '../../service/masterData.service';
import { IconButton, Slider, Grid, Chip, Typography, Box, Badge, Popover, useMediaQuery } from '@mui/material';
import StatusDialog from '../Status/StatusDialog';
import { ProjectPage } from '../Project/ProjectPage';
import { ResourceOnePage } from '../Resources/NewResourceOne/ResourceOnePage';
import { TaskFeedbackPage } from '../TaskFeedback/TaskFeedbackPage';
import { SimpleTaskForm } from '../NewSimpleTask/SimpleTaskForm';
import { SimpleTaskPhoneForm } from '../SimpleTaskPhone/SimpleTaskPhoneForm';
import { useProject } from '../../hooks/useProject';
import { useResourceOne } from '../../hooks/useResourceOne';
import { useTaskFeedback } from '../../hooks/useTaskFeedback';
import { useSimpleTask } from '../../hooks/useSimpleTask';
import AddDialog from './AddDialog';
import TaskListReportDialog from '../TaskListReport/TaskListReportDialog';
import { getResponsibleList } from '../../utils/getResponsibleList';
import { TaskResponsibleTypeEnum } from '../../config/taskList';
import EditNotificationsIcon from '@mui/icons-material/EditNotifications';
import SimpleTaskDeadLineNotificationDialog from '../SimpleTaskDeadLineNotification/SimpleTaskDeadLineNotificationDialog';
import useSimpleTaskDeadLineNotify from '../../context/SimpleTaskDeadLineNotifyContext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import CardMenu from './CardMenu';
import { ProjectTaskPage } from '../ProjectTasks/ProjectTaskPage';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { colorLinkType } from '../../config/app';
import CommentDialog from '../Comment/CommentDialog';
import useMenus from '../../context/MenuContext';
import appService from '../../service/app.service';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import OrderMenu from './OrderMenu';
import KanbanFilters from './KanbanFilters';
import ViewSelectField from './ViewSelectField';
import colorFinder from '../../utils/colorFinder';
import { NotificationType } from '../../config';
import addNotification from '../../utils/addNotification';
import { ResourceThreePage } from '../Resources/ResourceThree/ResourceThreePage';
import { useResourceThree } from '../../hooks/useResourceThree';
import useProjectTasks from '../../hooks/useProjectTasks';
import { TagType } from '../../config/tag';

const ComponentMap = {
  [KanbanType.PROJECT]: ProjectPage,
  [KanbanType.RESOURCE]: ResourceOnePage,
  [KanbanType.FEEDBACK]: TaskFeedbackPage,
  [KanbanType.TASK]: SimpleTaskForm,
  [KanbanType.TASKLIST]: ProjectTaskPage,
  [KanbanType.RESOURCETHREE]: ResourceThreePage,
};

const NewKanbanView = () => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const { menus, getMenus, getMenuSubMenuId, getSubMenuNamesByUrls } = useMenus();
  const navigate = useNavigate();
  const projectState = useProject();
  const resourceOneState = useResourceOne();
  const taskFeedbackState = useTaskFeedback();
  const simpleTaskState = useSimpleTask();
  const resourceThreeState = useResourceThree();
  const projectTasksState = useProjectTasks();
  const { getUser, user, getRole } = useUsers();
  const { subMenuName, projectTypeId } = useParams();
  const { getSetSimpleTaskDeadLineNotify, simpleTaskDeadLineNotify } = useSimpleTaskDeadLineNotify();
  const saveView = useSaveView(user);
  const kanbanFilter = useView('kanbanFilter', user);
  const { getParam, params } = useParam();
  const { showLoader, hideLoader } = useLoader();
  const [kanbanData, setKanbanData] = useState([]);
  const [item, setItem] = useState([]);
  const [dialogData, setDialogData] = useState({
    open: false,
    overrideType: null,
  });
  const [messageDialogOpen, setMessageDialogOpen] = useState(false);
  const [filterFormState, setFilterFormState] = useState({});
  const [loading, setLoading] = useState(null);
  const [type, setType] = useState('');
  const [defaultFilterFields, setDefaultFilterFields] = useState([]);
  const [taskChanged, setTaskChanged] = useState(false);
  const [messageData, setMessageData] = useState({
    addressedTo: null,
    eventData: {},
  });
  const [status, setStatus] = useState({});
  const [statusDialogOpen, setStatusDialogOpen] = useState(false);
  const [autoCompleteOptions, setAutoCompleteOptions] = useState({
    user: [],
    company: [],
    project: [],
    responsible: [],
    classification: [],
    priority: [],
    companyLocation: [],
    tagLabel: [],
  });
  const [autoCompleteData, setAutoCompleteData] = useState({});
  const [refetch, setRefetch] = useState(false);
  const [roles, setRoles] = useState({});
  const [colorDialogOpen, setColorDialogOpen] = useState({
    open: false,
    lineId: null,
    subMenuUrl: '',
    type: '',
  });
  const [dialogParams, setDialogParams] = useState(null);
  const [addDialogData, setAddDialogData] = useState({ open: false, dialogData: {}, overrideType: null });
  const [reportDialogOpen, setReportDialogOpen] = useState({ open: false, data: {} });
  const [isLoading, setIsLoading] = useState(true);
  const [responsibleType, setResponsibleType] = useState(null);
  const [notificationDialogOpen, setNotificationDialogOpen] = useState(false);
  const defSlideCount = 3;
  const maxSlideCount = 3;
  const [slideCount, setSlideCount] = useState(defSlideCount);
  const [collapsedCols, setCollapsedCols] = useState([]);
  const [menuPosition, setMenuPosition] = useState(null);
  const [cardMenuData, setCardMenuData] = useState({});
  const defCommentDialogData = {
    open: false,
    lineId: null,
    subMenuUrl: '',
  };
  const [commentDialogData, setCommentDialogData] = useState(defCommentDialogData);
  const [permissions, setPermissions] = useState([]);
  const [permissionLoaded, setPermissionLoaded] = useState(false);
  const [accessDenied, setAccessDenied] = useState(false);
  const [orderMenu, setOrderMenu] = useState({ order: null, statusId: null, position: null });
  const [kanbanOrders, setKanbanOrders] = useState([]);
  const [tags, setTags] = useState([]);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);

  const [query, setQuery] = useState({
    filter: [],
  });

  const useViewPermissions = params.KANBAN_USE_PERMISSION_TO_VIEWS === 'Y';

  const isTypeAllowed = (kanbanType) => {
    if (!useViewPermissions) return true;

    const subMenuUrl = KanbanTypeToPermissionSubMenuUrl[kanbanType];
    const submenuId = getMenuSubMenuId(subMenuUrl);
    return allowedSubMenuIds.has(submenuId);
  };

  useEffect(() => {
    getMenus();
  }, []);

  useEffect(() => {
    const kanbanDialogConfig = KanbanDialog.find((card) => card.type === type);
    const paramName = kanbanDialogConfig?.paramName;

    if (params[paramName]) {
      const parsedParams = JSON.parse(params[paramName]);
      setDialogParams(parsedParams);
    }
  }, [params, type]);

  useEffect(() => {
    if (!kanbanFilter?.kanbanOrders) return;

    setKanbanOrders(kanbanFilter.kanbanOrders);
  }, [kanbanFilter]);

  useEffect(() => {
    if (!useViewPermissions) {
      setPermissions([]);
      setPermissionLoaded(true);
      return;
    }

    if (user?.roleId) {
      appService.getUserPermissions(user.roleId).then((data) => {
        setPermissions(data);
        setPermissionLoaded(true);
      });
    }
  }, [user, useViewPermissions]);

  const allowedSubMenuIds = useMemo(() => {
    if (!useViewPermissions) return null;
    return new Set(permissions.map((p) => p.subMenuId));
  }, [permissions, useViewPermissions]);

  useEffect(() => {
    if (!type) return;

    const submenuId = getMenuSubMenuId(KanbanTypeToPermissionSubMenuUrl[type]);

    const filterFields = filterFieldConfig.fields;

    const isClassificationShowOnType = filterFields.classificationId.types.includes(type);
    if (isClassificationShowOnType) getClassificationBySubmenu(submenuId);

    getPriorityBySubmenu(submenuId);
  }, [type, menus]);

  useEffect(() => {
    if (!Object.keys(user).length) getUser();
    if (!Object.keys(simpleTaskDeadLineNotify).length) getSetSimpleTaskDeadLineNotify();
    getParam();
  }, []);

  useEffect(() => {
    if (!Object.keys(params).length) return;
    if (type !== '') return;

    const defaultFromParam = params.KANBAN_DEFAULT_VIEW || KanbanType.TASK;

    if (!isTypeAllowed(defaultFromParam)) {
      setType('');
      setAccessDenied(true);
      return;
    }
    setAccessDenied(false);

    setType(defaultFromParam);
  }, [params, type, permissions]);

  useEffect(() => {
    if (Object.keys(user).length > 0) {
      const roles = getRole([
        'TASK_KANBAN_SEE_ONLY_OWN',
        'TASKLIST_KANBAN_SEE_ONLY_OWN',
        'TASKLIST_KANBAN_SEE_ONLY_OWN_AND_GROUP',
        'TASK_KANBAN_EDIT_DEADLINE_NOTIFICATION',
        'TASK_KANBAN_SEE_ONLY_OWNED',
        'FEEDBACK_KANBAN_SEE_ONLY_OWN',
        'FEEDBACK_KANBAN_SEE_ONLY_OWNED',
      ]);

      setRoles(roles);
      initDefaultValues(roles);
    }
  }, [user.userId]);

  useEffect(() => {
    if (subMenuName) {
      const resolvedType = NavigateUrlToKanbanType[subMenuName] || KanbanType.TASK;

      if (!isTypeAllowed(resolvedType)) {
        setType('');
        setAccessDenied(true);
        return;
      }
      setAccessDenied(false);

      setType(resolvedType);
    }
  }, [subMenuName, permissions]);

  useEffect(() => {
    getTagsByType();
  }, [type]);

  useEffect(() => {
    if (subMenuName) return;
    if (!Object.keys(kanbanFilter).length) return;

    const excludedViews = params.KANBAN_EXCLUDE_VIEWS
      ? JSON.parse(params.KANBAN_EXCLUDE_VIEWS).map((e) => e.viewName)
      : [];

    const savedType = kanbanFilter?.viewType;
    if (!savedType) return;

    const defaultFromParam = params.KANBAN_DEFAULT_VIEW || KanbanType.TASK;

    if (excludedViews.includes(savedType)) {
      if (isTypeAllowed(defaultFromParam)) {
        setType(defaultFromParam);
      } else {
        setType('');
        setAccessDenied(true);
      }

      return;
    }

    if (!isTypeAllowed(savedType)) {
      setType('');
      setAccessDenied(true);
      return;
    }
    setAccessDenied(false);

    setType(savedType);
  }, [kanbanFilter, subMenuName, params, permissions]);

  useEffect(() => {
    if (taskChanged) {
      getItemsByType();
      setTaskChanged(false);
    }
  }, [taskChanged]);

  const kanbanViewAccess =
    params.KANBAN_VIEW_ACCESS && params.KANBAN_VIEW_ACCESS.split(',').map((access) => parseInt(access));

  const loadResponsiblePersonValue = params.KANBAN_RESPONSIBLE_PERSON_DEFAULT;

  const hasAccess = kanbanViewAccess && kanbanViewAccess.includes(user.userId) ? 'Y' : 'N';

  useEffect(() => {
    if (isLoading) return;
    if (!type) return;

    const base = KanbanFilterFormState[type] ?? {};
    const next = { ...base };

    if (type === KanbanType.TASKLIST) {
      if (roles.TASKLIST_KANBAN_SEE_ONLY_OWN_AND_GROUP) {
        const userGroupsForUser = autoCompleteOptions.userGroup.map((group) => group.value);

        next.userGroupId = userGroupsForUser;
        next.responsiblePersonId = user.userId;
      } else if (roles.TASKLIST_KANBAN_SEE_ONLY_OWN) {
        next.responsiblePersonId = user.userId;
      }
    }

    if (type === KanbanType.TASKLIST || type === KanbanType.PROJECT) {
      if (projectTypeId) {
        next.projectTypeId = parseInt(projectTypeId);
      } else if (type === KanbanType.PROJECT && params.PROJECT_SHOW_PROJECT_TYPE_STATUS === 'Y') {
        next.projectTypeId = autoCompleteOptions.projectType?.[0]?.value;
      }
    }

    if (type === KanbanType.FEEDBACK) {
      if (roles.FEEDBACK_KANBAN_SEE_ONLY_OWNED) {
        next.createdBy = user.userId;
      }

      if (roles.FEEDBACK_KANBAN_SEE_ONLY_OWN) {
        const userGroupsForUser = autoCompleteOptions.userGroup.map((group) => group.value);
        next.relevantDepartmentId = userGroupsForUser;
      }
    }

    if (type === KanbanType.TASK) {
      if (
        loadResponsiblePersonValue === 'Y' ||
        loadResponsiblePersonValue === undefined ||
        roles.TASK_KANBAN_SEE_ONLY_OWN
      ) {
        next.resposiblePersonId = user.userId;
      }

      if (roles.TASK_KANBAN_SEE_ONLY_OWNED) {
        next.userId = user.userId;
      }
    }

    setFilterFormState(next);
  }, [type, user.userId, roles, isLoading]);

  useEffect(() => {
    const defaultFilter = [
      {
        field: 'deletedBy',
        value: null,
      },
    ];

    const currentConditions = conditions[type || KanbanType.TASK];
    const newFilter = generateFilter(filterFormState, currentConditions);
    setQuery((prev) => {
      return { ...prev, filter: [...defaultFilter, ...newFilter] };
    });
    setDefaultFilterFields(defaultFilter);
  }, [filterFormState]);

  useEffect(() => {
    if (refetch) {
      getItemsByType();
    }
  }, [refetch]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (defaultFilterFields.length > 0 && query.filter.length > 0 && !isLoading) {
        getItemsByType();
      }
    }, 100);

    return () => clearTimeout(delayDebounceFn);
  }, [query, defaultFilterFields.length, isLoading]);

  const refreshKanbanBoard = params.KANBAN_BOARD_TIMED_UPDATE && Number(params.KANBAN_BOARD_TIMED_UPDATE);

  useEffect(() => {
    if (
      query &&
      type &&
      hasAccess &&
      refreshKanbanBoard &&
      typeof refreshKanbanBoard === 'number' &&
      refreshKanbanBoard > 0
    ) {
      const intervalId = setInterval(getItemsByType, refreshKanbanBoard);

      return () => clearInterval(intervalId);
    }
  }, [query, type, hasAccess]);

  const excludeViews = params.KANBAN_EXCLUDE_VIEWS ? JSON.parse(params.KANBAN_EXCLUDE_VIEWS) : [];

  const enabledOptionalViews = params.KANBAN_ENABLED_OPTIONAL_VIEWS
    ? JSON.parse(params.KANBAN_ENABLED_OPTIONAL_VIEWS)
    : [];

  const submenuNames = useMemo(() => {
    return getSubMenuNamesByUrls(['resourceOne', 'resourceThree']);
  }, [menus]);

  const isTypeEnabled = (type) => {
    if (!OptionalKanbanTypes.includes(type)) {
      return true;
    }

    return enabledOptionalViews.includes(type);
  };

  const filteredViewType = useMemo(() => {
    return ViewType.filter((view) => {
      const isExcluded = excludeViews.some((exclude) => exclude.viewName === view.value);

      return isTypeEnabled(view.value) && isTypeAllowed(view.value) && !isExcluded;
    }).map((view) => {
      const dynamicLabels = {
        [KanbanType.RESOURCE]: submenuNames[0],
        [KanbanType.RESOURCETHREE]: submenuNames[1],
      };

      return {
        ...view,
        label: dynamicLabels[view.value] ?? view.label,
      };
    });
  }, [permissions, excludeViews, enabledOptionalViews, submenuNames]);

  const getViewField = (targetType) => {
    const resolvedType = targetType ?? type;

    switch (resolvedType) {
      case KanbanType.PROJECT:
        return projectState.viewField;
      case KanbanType.RESOURCE:
        return resourceOneState.viewField;
      case KanbanType.FEEDBACK:
        return taskFeedbackState.viewField;
      case KanbanType.TASK:
        return simpleTaskState.viewField;
      case KanbanType.RESOURCETHREE:
        return resourceThreeState.viewField;
      case KanbanType.TASKLIST:
        return projectTasksState.viewField;
      default:
        return null;
    }
  };

  const getTagsByType = () => {
    if (!TagEnabledForTypes.includes(type)) {
      setTags([]);
      setAutoCompleteOptions((prev) => ({
        ...prev,
        tagLabel: [],
      }));
      return;
    }

    masterDataService.tagsByTargetToForm(type).then((data) => {
      const labels = data.filter((item) => item.tagType === TagType.LABEL);
      setTags(data);
      setAutoCompleteOptions((prev) => ({
        ...prev,
        tagLabel: generateAutocompleteItems(labels, 'name', 'id'),
      }));
    });
  };

  const getClassificationBySubmenu = (submenuId) => {
    if (!submenuId) return;

    masterDataService.classificationToForm(submenuId).then((data) => {
      setAutoCompleteData((prev) => ({
        ...prev,
        classification: data.classificationItem,
      }));

      setAutoCompleteOptions((prev) => ({
        ...prev,
        classification: generateAutocompleteItems(data.classificationItem, 'name', 'id'),
      }));
    });
  };

  const getPriorityBySubmenu = (submenuId) => {
    if (!submenuId || !PriorityVisibleForTypes.includes(type)) {
      setAutoCompleteData((prev) => ({
        ...prev,
        priority: [],
      }));

      setAutoCompleteOptions((prev) => ({
        ...prev,
        priority: [],
      }));

      return;
    }

    masterDataService.priorityToForm(submenuId).then((data) => {
      setAutoCompleteData((prev) => ({
        ...prev,
        priority: data.priorityListItems,
      }));

      setAutoCompleteOptions((prev) => ({
        ...prev,
        priority: generateAutocompleteItems(data.priorityListItems, 'itemName', 'itemId'),
      }));
    });
  };

  const dialogType = dialogData.overrideType ?? type;
  const SpecificComponent = ComponentMap[dialogType] ?? null;

  const AddSpecificComponent = useMemo(() => {
    const dialogType = addDialogData?.overrideType ?? type;
    const openPhoneTaskForm = params.KANBAN_OPEN_PHONE_TASK_FORM === 'Y';

    if (dialogType === KanbanType.TASK && isMobile && openPhoneTaskForm) {
      return SimpleTaskPhoneForm;
    }

    return ComponentMap[dialogType] ?? null;
  }, [addDialogData?.overrideType, type, isMobile]);

  const initDefaultValues = (rolesParam) => {
    const promiseArray = [];

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .usersToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .companyToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .projectTypeToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .projectToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .userGroupsToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(getResponsibleList());

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .companyLocationToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    Promise.all(promiseArray)
      .then((resp) => {
        const aData = {
          user: resp[0],
          company: resp[1],
          projectType: resp[2],
          project: resp[3],
          userGroup: resp[4],
          responsible: resp[5],
          companyLocation: resp[6],
        };

        const userGroup =
          rolesParam?.TASKLIST_KANBAN_SEE_ONLY_OWN_AND_GROUP || rolesParam?.FEEDBACK_KANBAN_SEE_ONLY_OWN
            ? aData.userGroup.filter((group) => group.userGroupUserLink?.some((link) => link.userId === user.userId))
            : aData.userGroup;

        setAutoCompleteData((prev) => ({
          ...prev,
          ...aData,
          userGroup,
        }));

        const acOptions = {
          user: generateAutocompleteItems(aData.user, 'nickName', 'userId'),
          company: generateAutocompleteItems(aData.company, 'name', 'id'),
          projectType: generateAutocompleteItems(aData.projectType, 'name', 'id'),
          project: generateAutocompleteItems(aData.project, ['projectName', 'orderNumber'], 'projectId'),
          userGroup: generateAutocompleteItems(userGroup, 'name', 'id'),
          responsible: aData.responsible,
          companyLocation: generateAutocompleteItems(aData.companyLocation, 'name', 'id'),
        };
        setAutoCompleteOptions((prev) => ({
          ...prev,
          ...acOptions,
        }));
      })
      .finally(() => {
        setIsLoading(false);
        //hideLoader();
      });
  };

  const getItemsByType = () => {
    if (!type) return;

    showLoader();
    kanbanService
      .getItemsByType(type, query, hasAccess)
      .then((data) => {
        setKanbanData(data);
        setRefetch(false);
      })
      .finally(() => {
        hideLoader();
      });
  };

  const getItemById = (id, overrideType = null) => {
    const itemType = overrideType ?? type;

    showLoader();

    kanbanService
      .getItemById(itemType, id)
      .then((data) => {
        setItem(data);
        setDialogData({
          open: true,
          overrideType,
        });
        handleClose();
      })
      .finally(() => {
        hideLoader();
      });
  };

  const handleDropAndStatusUpdate = (statusId, kanbanItem) => {
    setLoading(kanbanItem.id);
    const newStatus = kanbanData.find((kanbanColumn) => kanbanColumn.itemId === statusId);

    const updatedColumn = {
      ...kanbanItem,
      statusId: statusId,
      propertyId: kanbanItem.propertyId ?? null,
      preparedness: newStatus.preparedness ? Number(newStatus.preparedness) : null,
      status: {
        ...kanbanItem.status,
        itemName: newStatus.itemName,
        color: newStatus.color,
        statusId: newStatus.itemId,
      },
    };

    kanbanService
      .updateItemsByType(type, kanbanItem.id, statusId, updatedColumn)
      .then((data) => {
        if (type === KanbanType.TASKLIST) {
          setRefetch(true);
        } else {
          setKanbanData((prev) => {
            return prev.map((kanbanColumn) => {
              if (kanbanColumn.itemId === data.statusId) {
                return {
                  ...kanbanColumn,
                  items: [data, ...kanbanColumn.items.filter((item) => item.id !== kanbanItem.id)],
                };
              } else if (kanbanColumn.itemId === kanbanItem.statusId) {
                return {
                  ...kanbanColumn,
                  items: kanbanColumn.items.filter((item) => item.id !== kanbanItem.id),
                };
              }
              return kanbanColumn;
            });
          });
        }
        addNotification({
          content: 'Sikeres státuszváltás!',
          type: NotificationType.SUCCESS,
        });
      })
      .finally(() => {
        setLoading(null);
      });
  };

  const onDragStart = (event, kanbanItem) => {
    event.dataTransfer.setData('kanbanItem', JSON.stringify(kanbanItem));
  };

  const showMessageDialogParam = params.KANBAN_SHOW_MESSAGE_DIALOG ? JSON.parse(params.KANBAN_SHOW_MESSAGE_DIALOG) : [];

  const showMessageDialog =
    showMessageDialogParam && showMessageDialogParam.find((dialogPr) => dialogPr.kanbanType.includes(type));

  const handleStatusChange = (statusId, kanbanItem) => {
    if (loading || kanbanItem.statusId === statusId) return;

    handleDropAndStatusUpdate(statusId, kanbanItem);

    if (showMessageDialog) {
      setMessageDialogOpen(true);
      setMessageData((prev) => ({
        ...prev,
        eventData: kanbanItem,
      }));
    }
  };

  const onDragOver = (event) => {
    event.preventDefault();
  };

  const onDrop = (event, statusId) => {
    event.preventDefault();

    const kanbanItem = JSON.parse(event.dataTransfer.getData('kanbanItem'));

    handleStatusChange(statusId, kanbanItem);
  };

  const handleSimpleFilterChange = (fieldName, newValue) => {
    setFilterFormState((prev) => ({
      ...prev,
      [fieldName]: newValue,
    }));
  };

  const handleAutocompleteChange = (fieldName, newVal, reason, control) => {
    setFilterFormState((prev) => {
      if (control === 'multiAutocomplete') {
        return {
          ...prev,
          [fieldName]: reason === 'clear' ? [] : (newVal ?? []).map((v) => v.value),
        };
      }

      setResponsibleType(null);

      if (fieldName === 'responsible') {
        const fieldByType = {
          [TaskResponsibleTypeEnum.USER]: 'responsiblePersonId',
          [TaskResponsibleTypeEnum.USERGROUP]: 'responsibleUserGroupId',
          [TaskResponsibleTypeEnum.BUSINESSPARTNER]: 'responsibleCompanyId',
          [TaskResponsibleTypeEnum.WORKER]: 'responsibleWorkerId',
        };

        setResponsibleType(newVal?.type ?? null);

        const allFields = Object.values(fieldByType);
        const activeField = fieldByType[newVal?.type];

        return {
          ...prev,
          // minden responsible mező törlése
          ...Object.fromEntries(allFields.map((f) => [f, ''])),

          // csak az aktuális típus kap értéket
          ...(activeField && {
            [activeField]: reason === 'clear' ? '' : newVal?.value ?? '',
          }),
        };
      }

      return {
        ...prev,
        [fieldName]: reason === 'clear' ? '' : newVal?.value ?? '',
      };
    });
  };

  const handleDeleteItemByType = () => {
    kanbanService.deleteItemByType(type, cardMenuData.id).then(() => {
      setKanbanData((prev) =>
        prev.map((kanbanCol) => ({
          ...kanbanCol,
          items: kanbanCol.items.filter((item) => item.id !== cardMenuData.id),
        }))
      );
      handleClose();
    });
  };

  const addOrRemoveRespPerson = (userId) => {
    kanbanService.addOrRemoveRespPersonByType(type, cardMenuData.id, userId).then((data) => {
      setKanbanData((prev) =>
        prev.map((kanbanCol) => ({
          ...kanbanCol,
          items: kanbanCol.items.map((item) =>
            item.id === cardMenuData.id
              ? {
                  ...item,
                  respPersonlist: data.respPersonlist,
                  messages: data.messages,
                }
              : item
          ),
        }))
      );
    });
  };

  const updateRespPerson = (userId) => {
    kanbanService.updateRespPersonByType(type, cardMenuData.id, userId).then((data) => {
      if (filterFormState.responsiblePersonId || filterFormState.resposiblePersonId || filterFormState.userId) {
        setRefetch(true);
        handleClose();
      } else {
        setKanbanData((prev) =>
          prev.map((kanbanCol) => ({
            ...kanbanCol,
            items: kanbanCol.items.map((item) =>
              item.id === cardMenuData.id
                ? {
                    ...item,
                    responsiblePerson: data.responsiblePerson,
                    ...(type === KanbanType.TASK
                      ? { resposiblePersonId: data.resposiblePersonId }
                      : { responsiblePersonId: data.responsiblePersonId }),
                    messages: data.messages,
                  }
                : item
            ),
          }))
        );
      }
    });
  };

  const handleSwitchChange = (e) => {
    const { name, checked } = e.target;
    if (!name) return;

    if (!checked) {
      setFilterFormState((prev) => {
        const updatedState = { ...prev };
        delete updatedState[name];
        return updatedState;
      });
      return;
    }

    setFilterFormState((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleCollapseCol = (statusId) => {
    setCollapsedCols((prev) =>
      prev.includes(statusId) ? prev.filter((item) => item !== statusId) : [...prev, statusId]
    );
  };

  const getGridSize = () => {
    switch (slideCount) {
      case 3:
        return 12;
      case 2:
        return 6;
      case 1:
        return 4;
      default:
        return 12;
    }
  };

  const handleClick = (event, data) => {
    setMenuPosition(menuPosition === null ? { mouseX: event.clientX + 2, mouseY: event.clientY - 6 } : null);
    setCardMenuData(data);
  };

  const handleClose = () => {
    setMenuPosition(null);
    setCardMenuData({});
  };

  const handleOpenColorDialog = () => {
    setColorDialogOpen({
      open: true,
      lineId: cardMenuData.id,
      id: cardMenuData.id,
      subMenuUrl: KanbanTypeToSubMenuUrl[type],
      type: colorLinkType.KANBAN,
    });
    handleClose();
  };

  const handleOpenCommentDialog = (id) => {
    setCommentDialogData({
      open: true,
      lineId: cardMenuData.id ?? id,
      subMenuUrl: KanbanTypeToSubMenuUrl[type],
    });
    handleClose();
  };

  const currentItem = kanbanData.flatMap((col) => col.items).find((item) => item.id === cardMenuData.id);

  const handleRefetchColorChange = (id, color) => {
    setKanbanData((prev) =>
      prev.map((col) => ({
        ...col,
        items: col.items.map((it) => (it.id === id ? { ...it, color: color } : it)),
      }))
    );
  };

  const updatePriorityByType = (priorityId) => {
    kanbanService.updatePriorityByType(type, cardMenuData.id, priorityId).then((data) => {
      setKanbanData((prev) =>
        prev.map((col) => ({
          ...col,
          items: col.items.map((it) =>
            it.id === cardMenuData.id
              ? {
                  ...it,
                  ...(type === KanbanType.TASK ? { priorId: data.priorId } : { priorityId: data.priorityId }),
                  priority: data.priority,
                }
              : it
          ),
        }))
      );
    });
  };

  const updateTagByType = (tagId) => {
    kanbanService.updateTagByType(type, cardMenuData.id, tagId).then((data) => {
      setKanbanData((prev) =>
        prev.map((col) => ({
          ...col,
          items: col.items.map((it) =>
            it.id === cardMenuData.id
              ? {
                  ...it,
                  tagLink: data.tagLink,
                }
              : it
          ),
        }))
      );
    });
  };

  const handleOrderClick = (field) => {
    setKanbanOrders((prev) => {
      const current = prev.find((o) => o.statusId === orderMenu.statusId);

      if (current && current.field === field && current.sort === orderMenu.order) {
        const next = prev.filter((o) => o.statusId !== orderMenu.statusId);

        saveView('kanbanFilter', {
          kanbanOrders: next,
        });

        return next;
      }

      const nextOrder = {
        statusId: orderMenu.statusId,
        field,
        sort: orderMenu.order,
      };

      const next = [...prev.filter((o) => o.statusId !== orderMenu.statusId), nextOrder];

      saveView('kanbanFilter', {
        kanbanOrders: next,
      });

      return next;
    });

    setOrderMenu({
      order: null,
      position: null,
      statusId: null,
    });
  };

  const displayedKanbanData = useMemo(() => {
    return kanbanData.map((col) => {
      const order = kanbanOrders.find((o) => o.statusId === col.itemId);

      const color = colorFinder(col.color);

      const displayedColumn = {
        ...col,
        statusColor: color?.colorCode ?? col.color,
      };

      if (!order) return displayedColumn;

      return {
        ...displayedColumn,
        items: [...col.items].sort((a, b) => {
          const aValue = a[order.field];
          const bValue = b[order.field];

          if (aValue == null && bValue == null) return 0;
          if (aValue == null) return 1;
          if (bValue == null) return -1;

          if (aValue < bValue) return order.sort === 'asc' ? -1 : 1;
          if (aValue > bValue) return order.sort === 'asc' ? 1 : -1;

          return 0;
        }),
      };
    });
  }, [kanbanData, kanbanOrders]);

  const kanbanFilterProps = {
    type,
    filterFormState,
    autoCompleteOptions,
    responsibleType,
    roles,
    handleSimpleFilterChange,
    handleAutocompleteChange,
    handleSwitchChange,
  };

  const viewSelectProps = {
    filteredViewType,
    type,
    setType,
    saveView,
    navigate,
    subMenuName,
  };

  const activeFilterCount = Object.values(filterFormState).reduce((count, value) => {
    if (Array.isArray(value)) {
      return count + (value.length > 0 ? 1 : 0);
    }

    return count + (value ? 1 : 0);
  }, 0);

  const handleOpenFilters = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleCloseFilters = () => {
    setFilterAnchorEl(null);
  };

  return (
    <div className="bg-white relative w-full px-3 pb-3 font-poppins" style={{ minHeight: 'calc(100vh - 65px)' }}>
      {isMobile ? (
        <div className="mt-2 flex items-center justify-between gap-3">
          <ViewSelectField {...viewSelectProps} />
          <IconButton
            disableRipple
            onClick={handleOpenFilters}
            sx={{
              backgroundColor: '#78b8ef',
              color: '#fff',
              borderRadius: 2,
              p: 0.4,
            }}
          >
            <Badge badgeContent={activeFilterCount} color="secondary">
              <FilterAltOutlinedIcon fontSize="large" />
            </Badge>
          </IconButton>
        </div>
      ) : (
        <>
          {params.SHOW_KANBAN_TASK_DEADLINE_NOTIFICATION_ICON === 'Y' &&
            roles.TASK_KANBAN_EDIT_DEADLINE_NOTIFICATION && (
              <div className="fixed top-[10px] lg:right-[170px] z-40">
                <IconButton onClick={() => setNotificationDialogOpen(true)}>
                  <EditNotificationsIcon sx={{ fontSize: '1.8rem' }} />
                </IconButton>
              </div>
            )}
          <div className="xl:left-80 z-0 xl:z-40 xl:absolute xl:-top-14">
            <div className="flex flex-col md:flex-row w-full md:gap-3">
              <ViewSelectField {...viewSelectProps} />
              <KanbanFilters {...kanbanFilterProps} />
              {type && (
                <div className="mt-2 md:mt-0 w-[100px] xl:text-white">
                  <p className="text-center">Zoom</p>
                  <Slider
                    defaultValue={slideCount}
                    step={1}
                    min={1}
                    max={maxSlideCount}
                    sx={{
                      '@media (min-width:1140px)': {
                        color: 'white',
                      },
                    }}
                    onChange={(e) => setSlideCount(e.target.value)}
                  />
                </div>
              )}
            </div>
          </div>
        </>
      )}

      <Popover
        id="todo-filter-popover"
        open={Boolean(filterAnchorEl)}
        anchorEl={filterAnchorEl}
        onClose={handleCloseFilters}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        slotProps={{
          paper: {
            sx: {
              width: 360,
              p: 2,
            },
          },
        }}
      >
        <KanbanFilters {...kanbanFilterProps} />
      </Popover>
      {!accessDenied ? (
        <div className="overflow-x-auto custom-scrollbar md:overflow-x-auto snap-x snap-mandatory scroll-smooth md:snap-none">
          <div className="mt-4 xl:pt-0 flex gap-3 md:w-full">
            {displayedKanbanData.map((kanban, index) => {
              const isCollapsed = collapsedCols.includes(kanban.itemId);
              const columnOrder = kanbanOrders.find((order) => order.statusId === kanban.itemId);

              return (
                <div
                  onClick={isCollapsed ? () => handleCollapseCol(kanban.itemId) : undefined}
                  key={kanban.itemId}
                  className="relative bg-[#fafafa] text-[#1A1A1A] transition-all snap-start snap-always"
                  style={{
                    minWidth: isCollapsed ? 50 : isMobile ? '100%' : 370,
                    flex: isCollapsed ? '0 0 50px' : isMobile ? '0 0 100%' : '1 1 370px',
                    borderRadius: '8px',
                    borderTop: `7px solid ${kanban.statusColor}`,
                  }}
                >
                  <div
                    onDragOver={(event) => onDragOver(event)}
                    onDrop={(event) => onDrop(event, kanban.itemId)}
                    style={{
                      minWidth: 'auto',
                    }}
                  >
                    <div className={`flex items-center justify-between ${isCollapsed && 'flex-col-reverse'}`}>
                      <div
                        className={`p-[14px] text-[16px] relative flex justify-between items-center font-semibold break-words [overflow-wrap:anywhere] w-[100%] ${isCollapsed && 'whitespace-nowrap rotate-90 gap-3'}`}
                      >
                        <p className={`${!isCollapsed && 'line-clamp-2'}`}>{kanban.itemName}</p>
                        <div className="flex items-center gap-5">
                          {!isCollapsed && orderColumnsByType[type] && (
                            <div>
                              <IconButton
                                sx={{ m: 0, p: 0.2 }}
                                onClick={(e) => {
                                  setOrderMenu({
                                    order: 'asc',
                                    statusId: kanban.itemId,
                                    position: { mouseX: e.clientX + 2, mouseY: e.clientY - 6 },
                                  });
                                }}
                              >
                                <ArrowUpwardIcon sx={{ color: columnOrder?.sort === 'asc' ? '#1976d2' : '#808080' }} />
                              </IconButton>
                              <IconButton
                                sx={{ m: 0, p: 0.2 }}
                                onClick={(e) => {
                                  setOrderMenu({
                                    order: 'desc',
                                    statusId: kanban.itemId,
                                    position: { mouseX: e.clientX + 2, mouseY: e.clientY - 6 },
                                  });
                                }}
                              >
                                <ArrowDownwardIcon
                                  sx={{ color: columnOrder?.sort === 'desc' ? '#1976d2' : '#808080' }}
                                />
                              </IconButton>
                            </div>
                          )}
                          <Chip
                            label={kanban.items.length}
                            sx={{
                              background: '#f2f2f2',
                              color: '#808080',
                            }}
                          />
                        </div>
                      </div>

                      <IconButton
                        sx={{ p: 0.5, mt: isCollapsed && 2 }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCollapseCol(kanban.itemId);
                        }}
                      >
                        {isCollapsed ? (
                          <KeyboardArrowRightIcon sx={{ fontSize: '1.7rem' }} />
                        ) : (
                          <KeyboardArrowLeftIcon sx={{ fontSize: '1.7rem' }} />
                        )}
                      </IconButton>
                    </div>
                    <div
                      className={`overflow-y-auto custom-scrollbar w-full pb-10 px-3 ${AddIconVisibleForTypes.includes(type) ? 'h-[calc(100vh-215px)]' : 'h-[calc(100vh-180px)]'}`}
                    >
                      <Grid container spacing={1}>
                        {kanban.items.map((data) => {
                          return (
                            <Grid
                              item
                              xs={12}
                              lg={getGridSize()}
                              width="100%"
                              key={data.id}
                              display={isCollapsed ? 'none' : 'block'}
                            >
                              <Card
                                type={type}
                                key={data.id}
                                data={data}
                                onDragStart={onDragStart}
                                statusColor={kanban.statusColor}
                                params={params}
                                loading={loading === data.id ? loading : null}
                                user={user}
                                setRefetch={setRefetch}
                                autoCompleteData={autoCompleteData}
                                handleClick={handleClick}
                                slideCount={slideCount}
                                getItemById={getItemById}
                                setReportDialogOpen={setReportDialogOpen}
                                handleOpenCommentDialog={handleOpenCommentDialog}
                                isMobile={isMobile}
                                statuses={displayedKanbanData}
                                handleStatusChange={handleStatusChange}
                              />
                            </Grid>
                          );
                        })}
                      </Grid>
                    </div>
                    <div className={`text-center ${isCollapsed ? 'hidden' : 'block'}`}>
                      {AddIconVisibleForTypes.includes(type) && (
                        <IconButton
                          onClick={() =>
                            setAddDialogData({
                              open: true,
                              dialogData:
                                type === KanbanType.PROJECT && params.PROJECT_SHOW_PROJECT_TYPE_STATUS
                                  ? {
                                      projectTypeId: filterFormState.projectTypeId,
                                      projectTypeStatusId: kanban.itemId,
                                    }
                                  : { statusId: kanban.itemId },
                            })
                          }
                        >
                          <AddCircleOutlineIcon sx={{ color: '#5c5c5c' }} />
                        </IconButton>
                      )}
                      {type === KanbanType.TASK && (
                        <TooltipUI title="Saját feladat" arrow>
                          <IconButton
                            onClick={() =>
                              setAddDialogData({
                                open: true,
                                dialogData: { statusId: kanban.itemId, resposiblePersonId: user.userId },
                              })
                            }
                          >
                            <AddCircleOutlineIcon sx={{ color: '#0fbd1d' }} />
                          </IconButton>
                        </TooltipUI>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        permissionLoaded && (
          <Box
            sx={{
              px: 6,
              py: 10,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Box sx={{ maxWidth: 900, textAlign: 'center' }}>
              <Typography
                sx={{
                  fontSize: { xs: '1.75rem', sm: '2.5rem' },
                  fontWeight: 700,
                  color: '#111827',
                }}
              >
                Hiányzó jogosultság a nézet megtekintéséhez!
              </Typography>
            </Box>
          </Box>
        )
      )}
      <Dialog
        open={dialogData.open}
        data={item}
        handleClose={() => {
          setDialogData({
            open: false,
            overrideType: null,
          });
          setItem({});
        }}
        type={dialogType}
        params={params}
        changed={{ taskChanged, setTaskChanged }}
        getViewField={getViewField}
        SpecificComponent={SpecificComponent}
        dialogParams={dialogParams}
        projectState={projectState}
        resourceOneState={resourceOneState}
        taskFeedbackState={taskFeedbackState}
        simpleTaskState={simpleTaskState}
        projectTasksState={projectTasksState}
        resourceThreeState={resourceThreeState}
      />

      <AddDialog
        addDialogData={addDialogData}
        handleClose={() => {
          setAddDialogData({ open: false, dialogData: {}, overrideType: null });
        }}
        changed={{ taskChanged, setTaskChanged }}
        getViewField={getViewField}
        SpecificComponent={AddSpecificComponent}
      />

      <TaskListReportDialog
        open={reportDialogOpen.open}
        handleClose={() => {
          setReportDialogOpen((prev) => ({
            ...prev,
            open: false,
          }));
        }}
        setTaskChanged={setTaskChanged}
        data={reportDialogOpen.data}
      />

      <MessageDialog
        open={messageDialogOpen}
        data={item}
        handleClose={() => {
          setMessageDialogOpen(false);
        }}
        type={type}
        params={params}
        message={{ messageData, setMessageData }}
        user={user}
        setRefetch={setRefetch}
      />

      <StatusDialog
        open={statusDialogOpen}
        handleClose={() => setStatusDialogOpen(false)}
        data={status}
        setDataChanged={setTaskChanged}
      />

      <CommentDialog
        dialogData={commentDialogData}
        handleClose={() => setCommentDialogData(defCommentDialogData)}
        setRefetchTable={setRefetch}
      />

      <ColorDialogUI
        open={colorDialogOpen.open}
        handleClose={() => setColorDialogOpen({ open: false, lineId: null, subMenuUrl: '', type: '' })}
        data={colorDialogOpen}
        setKanbanData={setKanbanData}
        refetchData={handleRefetchColorChange}
      />

      <SimpleTaskDeadLineNotificationDialog
        open={notificationDialogOpen}
        handleClose={() => setNotificationDialogOpen(false)}
      />

      <CardMenu
        handleClose={handleClose}
        open={Boolean(menuPosition)}
        menuPosition={menuPosition}
        getItemById={getItemById}
        handleDeleteItemByType={handleDeleteItemByType}
        autoCompleteData={autoCompleteData}
        addOrRemoveRespPerson={addOrRemoveRespPerson}
        currentItem={currentItem}
        updateRespPerson={updateRespPerson}
        type={type}
        handleOpenColorDialog={handleOpenColorDialog}
        handleOpenCommentDialog={handleOpenCommentDialog}
        updatePriorityByType={updatePriorityByType}
        tags={tags}
        updateTagByType={updateTagByType}
        setAddDialogData={setAddDialogData}
      />

      <OrderMenu
        orderMenu={orderMenu}
        handleClose={() => setOrderMenu({ order: null, statusId: null, position: null })}
        type={type}
        handleOrderClick={handleOrderClick}
        kanbanOrders={kanbanOrders}
      />
    </div>
  );
};

export default NewKanbanView;
